module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "lxm-contact-contact-info"
  }, [_c('transition', {
    attrs: {
      "name": "lxm-content-transition",
      "mode": "out-in"
    }
  }, [(!_vm.loading) ? _c('lxm-panel', {
    attrs: {
      "rows": _vm.baseRows
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "lxm-content-transition",
      "mode": "out-in"
    }
  }, [(!_vm.loading) ? _c('lxm-panel', {
    attrs: {
      "rows": _vm.attachRows
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "lxm-content-transition",
      "mode": "out-in"
    }
  }, [(!_vm.loading && _vm.statisticsRows.length > 0) ? _c('lxm-panel', {
    attrs: {
      "rows": _vm.statisticsRows,
      "valueStyle": _vm.vStyle
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "lxm-content-transition",
      "mode": "out-in"
    }
  }, [(!_vm.loading && _vm.otherRows.length > 0) ? _c('div', [(!_vm.loading && _vm.otherRows.length > 0) ? _c('lxm-panel', {
    attrs: {
      "rows": _vm.otherRows,
      "valueStyle": _vm.vStyle,
      "newLineStyle": _vm.newLineStyle
    }
  }) : _vm._e()], 1) : _vm._e()])], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-e0609220", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-e0609220!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Main/Contact/Contact/Info.vue
// module id = 889
// module chunks = 0